var _circle, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 71,
    height: 71,
    viewBox: "0 0 71 71",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 35.2152,
    cy: 35.2152,
    r: 35.2152,
    fill: "#00AF3C"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M57.0784 45.8793C58.8034 46.7207 59.5373 48.8165 58.4874 50.4232C55.3291 55.2566 50.7251 59.0131 45.2904 61.1266C38.7702 63.6621 31.5338 63.6463 25.0248 61.0824C18.5158 58.5184 13.2126 53.5947 10.1733 47.2936C7.13403 40.9925 6.58201 33.7772 8.62739 27.087C10.6728 20.3969 15.1652 14.7238 21.2084 11.1995C27.2516 7.67521 34.4014 6.55878 41.2314 8.07295C48.0614 9.58712 54.0695 13.6206 58.057 19.3687C61.3808 24.1598 63.0971 29.8487 63.0126 35.6218C62.9845 37.5409 61.2042 38.8681 59.3036 38.601V38.601C57.403 38.3338 56.1095 36.5701 56.0576 34.6515C55.9486 30.622 54.6722 26.6831 52.3463 23.3303C49.3556 19.0193 44.8495 15.9942 39.7271 14.8586C34.6046 13.7229 29.2422 14.5603 24.7098 17.2035C20.1774 19.8467 16.8081 24.1015 15.2741 29.1191C13.74 34.1367 14.154 39.5482 16.4335 44.2741C18.713 48.9999 22.6903 52.6926 27.5721 54.6156C32.4539 56.5386 37.8812 56.5504 42.7713 54.6488C46.5744 53.1698 49.8352 50.6181 52.1788 47.3384C53.2947 45.7769 55.3533 45.038 57.0784 45.8793V45.8793Z",
    fill: "#013D19"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M35.2134 31.5074H62.7059L63.0148 34.1846V38.9211H35.2134V31.5074Z",
    fill: "#013D19"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M33.0397 50.8354H31.2807L33.0397 38.5226H26.8833C25.3354 38.5226 26.3029 37.2034 26.338 37.1506C28.6071 33.1402 32.0195 27.1597 36.5752 19.174H38.3342L36.5752 31.4867H42.7492C43.4528 31.4867 43.8397 31.8209 43.4528 32.6477C36.5049 44.7669 33.0397 50.8354 33.0397 50.8354Z",
    fill: "#013D19"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/Logo.a873a06973abafadf1e00a134abf6b8d.svg";
export { ForwardRef as ReactComponent };